@if (bet?.events[0]?.markets?.length) {
    <div class="betting-container">
        <div id="{{ bet?.hashId }}" class="betting-content" data-crlat="preCreatedBetBuilderBettingContent">
            <div data-crlat="preCreatedBetBuilderSelectionDetailsInfo">
                @for (market of bet?.events[0]?.markets; track $index) {
                    @for (outcome of market?.outcomes; track $index) {
                        <div
                            data-crlat="preCreatedBetBuilderSelectionInfo"
                            class="selection-info"
                            [ngClass]="{
                                'last-line': isLastOutcome(bet?.events[0], market, outcome),
                                'suspended': market?.marketStatusCode === 'S' || outcome?.outcomeStatusCode === 'S',
                            }">
                            <div class="selection-details">
                                <div class="indicator" data-crlat="preCreatedBetBuilderIndicator"></div>
                                <div class="selection-text">
                                    <span
                                        class="selection-name"
                                        data-crlat="preCreatedBetBuilderSelectionName"
                                        [ngClass]="{ 'selection-name-lads': isLadbrokes }"
                                        [textContent]="outcome?.name">
                                    </span>
                                    <span
                                        class="market-name"
                                        data-crlat="preCreatedBetBuilderMarketName"
                                        [ngClass]="{ 'market-name-lads': isLadbrokes }"
                                        [textContent]="market?.name">
                                    </span>
                                </div>
                            </div>
                        </div>
                    }
                }
            </div>
            <pre-created-add-to-betslip
                [hashIdSignal]="bet?.hashId"
                [priceSignal]="bet?.aggregatedPrice"
                [eventRefSignal]="eventRef"
                [markets]="bet?.events[0]?.markets"
                [isSuspendedSignal]="bet?.isMktSuspended || bet?.isOcmSuspended"
                [isLadbrokes]="isLadbrokes">
            </pre-created-add-to-betslip>
        </div>
    </div>
}
